/**
 * OPS-specific display names
 * Uses "paarig" instead of "beidseitig" for paarig localization
 */
export enum OpsSeitenlokalisationDisplayNameEnum {
  Links = 'links',
  Paarig = 'paarig',
  Rechts = 'rechts',
  KeineAuswahl = 'keine Auswahl',
}
